/* jsl-prezent.js — J·SKIN LAB r5p (24.09.2026): prezent w sklepie, bez aplikacji.
 *  Karta produktu (snippets/jsl10-pdp-kup, części „prezent” i „subskrypcja”):
 *   - „Zapakuj na prezent”: pole properties[Prezent]=1 dołączone do formularza zakupu (atrybut form=), wyłączone, gdy nie zaznaczone;
 *     po udanym dodaniu (zdarzenie motywu cart:update z product-form-component) dokładamy pudełko (_grupa: 1) i liścik (atrybut koszyka);
 *     przy zaznaczonym prezencie chowamy płatności ekspresowe (one nie dodałyby pudełka) — bez prezentu działają jak zawsze.
 *   - subskrypcja: pole selling_plan dołączone do formularza; „Jednorazowo” = pole wyłączone.
 *  Koszyk i szuflada (snippets/cart-products + jsl-prezent-koszyk): przenoszenie pozycji między „Dla Ciebie” i „Prezent”
 *   (cart/change.js z właściwościami, przy ilości > 1 po jednej sztuce), „+ Drugi na prezent”, pudełko, wysyłka na drugi adres,
 *   liścik, adres, dokument → atrybuty koszyka (cart/update.js). Po zmianie pozycji motyw odświeża sekcje zdarzeniem cart:update.
 *  Wartości atrybutów są po polsku (czyta je właścicielka w panelu), teksty dla klientki przychodzą z tłumaczeń motywu (Liquid).
 */
(function () {
  if (window.jslPrezent) return;
  window.jslPrezent = true;

  var PUD = 'pudelko-prezentowe';
  var WYS = 'wysylka-prezentu';
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var A = {
    liscik: 'Prezent - liścik', wysylka: 'Prezent - wysyłka', adres: 'Prezent - adres',
    dok: 'Dokument', nip: 'NIP', wPaczce: 'Dokument w paczce', surowe: '_jsl_prezent'
  };
  var W = {
    razem: 'Razem z moim zamówieniem', inny: 'Na inny adres (osobna paczka)', innyUe: 'Na inny adres — do ustalenia (rynek UE)',
    paragon: 'Paragon', fakRazem: 'Faktura na firmę — jedna na całe zamówienie', fakOsobno: 'Faktura na firmę — osobna na prezent',
    bezCen: 'Nie — w paczce z prezentem bez dokumentu i cen', zCenami: 'Tak'
  };

  function api(sciezka, cialo) {
    return fetch(root + sciezka, {
      method: cialo ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: cialo ? JSON.stringify(cialo) : undefined
    }).then(function (r) { return r.json(); });
  }
  function koszyk() { return api('cart.js'); }
  // odświeżenie sekcji koszyka tak, jak robi to motyw (cart-items-component, licznik w nagłówku)
  function odswiez(cart) {
    var e = new Event('cart:update', { bubbles: true });
    e.detail = { resource: cart || null, sourceId: 'jsl-prezent', data: { source: 'jsl-prezent', itemCount: cart ? cart.item_count : 0 } };
    document.dispatchEvent(e);
  }
  function zajety(el, tak) { var k = el && el.closest('[data-jsl-kpr], .cart-items, .j-kpm'); if (k) k.classList.toggle('j-kpr--czeka', !!tak); }

  /* ───────────── karta produktu ───────────── */
  var FORM = 'form[data-type="add-to-cart-form"], product-form-component form';
  function formularzDla(el) {
    var sek = el.closest('.shopify-section, product-information, main') || document;
    var f = sek.querySelector(FORM) || document.querySelector(FORM);
    // uwaga: form.id zwraca pole <input name="id"> (wariant), nie atrybut — dlatego zawsze getAttribute/setAttribute
    if (f && !f.getAttribute('id')) f.setAttribute('id', 'jsl-pf-' + Math.random().toString(36).slice(2, 8));
    return f;
  }
  function idFormularza(f) { return f ? f.getAttribute('id') : null;
  }
  function przygotujPdp() {
    document.querySelectorAll('[data-jsl-prezent-pdp]').forEach(function (box) {
      var f = idFormularza(formularzDla(box)); var prop = box.querySelector('[data-jsl-pr-prop]');
      if (f && prop && prop.getAttribute('form') !== f) prop.setAttribute('form', f);
      var on = box.querySelector('[data-jsl-pr-on]');
      if (on && on.checked !== !prop.disabled) ustawPrezent(box, on.checked);
    });
    document.querySelectorAll('[data-jsl-sub]').forEach(function (fs) {
      var f = idFormularza(formularzDla(fs)); var pole = fs.querySelector('[data-jsl-sub-pole]');
      if (f && pole && pole.getAttribute('form') !== f) pole.setAttribute('form', f);
      var zazn = fs.querySelector('input[type=radio]:checked');
      if (zazn && pole) { pole.value = zazn.value; pole.disabled = !zazn.value; }
    });
  }
  function ekspres(box, ukryj) {
    var f = formularzDla(box); if (!f) return;
    f.querySelectorAll('.accelerated-checkout-block, shopify-accelerated-checkout, .shopify-payment-button, [data-shopify="payment-button"]').forEach(function (x) {
      x.style.display = ukryj ? 'none' : '';
    });
  }
  function ustawPrezent(box, on) {
    box.classList.toggle('is-on', on);
    var panel = box.querySelector('[data-jsl-pr-panel]'); if (panel) panel.hidden = !on;
    var prop = box.querySelector('[data-jsl-pr-prop]'); if (prop) prop.disabled = !on;
    ekspres(box, on);
  }
  var czeka = null; // prezent zaznaczony przy wysłaniu formularza → po udanym dodaniu dokładamy pudełko i liścik
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches(FORM) || !idFormularza(f)) return;
    var prop = document.querySelector('[data-jsl-pr-prop][form="' + idFormularza(f) + '"]');
    if (!prop || prop.disabled) { czeka = null; return; }
    var box = prop.closest('[data-jsl-prezent-pdp]');
    var pud = box.querySelector('input[name^="jsl-pud-"]:checked');
    var kolej = Array.prototype.map.call(box.querySelectorAll('input[name^="jsl-pud-"]'), function (x) { return x.value; });
    czeka = { pid: String(box.dataset.produkt), pud: pud ? pud.value : null, kolej: kolej, lis: (box.querySelector('[data-jsl-pr-lis]') || {}).value || '', t: Date.now() };
  }, true);
  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    if (!czeka || d.source !== 'product-form-component') return;
    if (d.didError || String(d.productId) !== czeka.pid || Date.now() - czeka.t > 30000) { czeka = null; return; }
    var c = czeka; czeka = null;
    dolozPudelko(c).catch(function (err) { console.error('jsl-prezent', err); });
  });
  function dolozPudelko(c) {
    return koszyk().then(function (cart) {
      var kroki = [];
      if (c.pud) {
        var jest = cart.items.filter(function (i) { return i.handle === PUD; });
        var poz = function (vid) { return c.kolej.indexOf(String(vid)); };
        var wiekszeJuz = jest.some(function (i) { return poz(i.variant_id) >= poz(c.pud); });
        if (!wiekszeJuz) {
          // jedno pudełko na prezent: zostaje większe z dwóch wyborów
          if (jest.length) { var up = {}; jest.forEach(function (i) { up[i.key] = 0; }); kroki.push(function () { return api('cart/update.js', { updates: up }); }); }
          kroki.push(function () { return api('cart/add.js', { items: [{ id: Number(c.pud), quantity: 1, properties: { _grupa: '1' } }] }); });
        }
      }
      var lis = c.lis.trim();
      var atr = {};
      if (lis && lis !== (cart.attributes || {})[A.liscik]) atr[A.liscik] = lis;
      if (!(cart.attributes || {})[A.wPaczce]) { atr[A.wPaczce] = W.bezCen; atr[A.dok] = W.paragon; atr[A.wysylka] = W.razem; }
      if (Object.keys(atr).length) kroki.push(function () { return api('cart/update.js', { attributes: atr }); });
      return kroki.reduce(function (p, k) { return p.then(k); }, Promise.resolve()).then(koszyk).then(odswiez);
    });
  }

  /* ───────────── koszyk ───────────── */
  function dane(kpr) { try { return JSON.parse(kpr.querySelector('[data-jsl-kpr-dane]').textContent); } catch (err) { return {}; } }
  function pole(kpr, n) { return kpr.querySelector('[data-jsl-kpole="' + n + '"]'); }
  function wart(kpr, n) { var p = pole(kpr, n); return p ? p.value.trim() : ''; }
  function wybrane(kpr, name) { var x = kpr.querySelector('input[name="' + name + '"]:checked'); return x ? x.value : ''; }

  function atrybutyZPanelu(kpr) {
    var d = dane(kpr); var o = {};
    o[A.liscik] = wart(kpr, 'liscik');
    var inny = wybrane(kpr, 'jsl-kadr') === 'inny';
    o[A.wysylka] = inny ? (d.rynek === 'pl' ? W.inny : W.innyUe) : W.razem;
    var surowe = { imie: wart(kpr, 'imie'), ulica: wart(kpr, 'ulica'), kod: wart(kpr, 'kod'), miasto: wart(kpr, 'miasto'), kraj: wart(kpr, 'kraj'), tel: wart(kpr, 'tel') };
    o[A.adres] = inny && d.rynek === 'pl'
      ? [surowe.imie, surowe.ulica, (surowe.kod + ' ' + surowe.miasto).trim(), surowe.kraj, surowe.tel ? 'tel. ' + surowe.tel : ''].filter(Boolean).join(', ')
      : '';
    o[A.surowe] = inny && d.rynek === 'pl' ? JSON.stringify(surowe) : '';
    var fak = wybrane(kpr, 'jsl-kdok') === 'faktura';
    o[A.dok] = fak ? (wybrane(kpr, 'jsl-kfak') === 'osobno' ? W.fakOsobno : W.fakRazem) : W.paragon;
    o[A.nip] = fak ? wart(kpr, 'nip') : '';
    var bc = kpr.querySelector('[data-jsl-kbezcen]');
    o[A.wPaczce] = bc && !bc.checked ? W.zCenami : W.bezCen;
    return o;
  }
  var zapisTimer = null; var zapisTrwa = null;
  function zapiszAtrybuty(kpr, zaraz) {
    clearTimeout(zapisTimer);
    var wykonaj = function () { zapisTrwa = api('cart/update.js', { attributes: atrybutyZPanelu(kpr) }).finally(function () { zapisTrwa = null; }); return zapisTrwa; };
    if (zaraz) return wykonaj();
    zapisTimer = setTimeout(wykonaj, 600);
    return null;
  }
  function wyczyscAtrybuty(attrs) {
    var o = {}; var jest = false;
    Object.keys(A).forEach(function (k) { if (attrs && attrs[A[k]]) { o[A[k]] = ''; jest = true; } });
    return jest ? api('cart/update.js', { attributes: o }) : Promise.resolve();
  }
  // po każdym renderze koszyka: wypełnij pola adresu z _jsl_prezent; bez grupy prezentu — wyczyść stare atrybuty prezentu
  var czyszczenie = false;
  function przygotujKoszyk() {
    document.querySelectorAll('[data-jsl-kpr]').forEach(function (kpr) {
      if (kpr.dataset.jslGotowe) return; kpr.dataset.jslGotowe = '1';
      var d = dane(kpr); var at = d.attrs || {};
      var s = {}; try { s = JSON.parse(at[A.surowe] || '{}'); } catch (err) { s = {}; }
      ['imie', 'ulica', 'kod', 'miasto', 'tel'].forEach(function (n) { var p = pole(kpr, n); if (p && !p.value && s[n] && document.activeElement !== p) p.value = s[n]; });
      if (!at[A.wPaczce]) zapiszAtrybuty(kpr, true);
    });
    var znacznik = document.querySelector('[data-jsl-kpr-czysc]');
    if (znacznik && !document.querySelector('[data-jsl-kpr]') && !czyszczenie) {
      czyszczenie = true; znacznik.remove();
      koszyk().then(function (cart) {
        var maGrupe = cart.items.some(function (i) { return (i.properties && i.properties.Prezent) || i.handle === PUD || i.handle === WYS; });
        return maGrupe ? null : wyczyscAtrybuty(cart.attributes);
      }).finally(function () { czyszczenie = false; });
    }
  }

  function przenies(b) {
    var props = {}; try { props = JSON.parse(b.dataset.props || '{}') || {}; } catch (err) { props = {}; }
    if (b.dataset.jslPrzenies === 'prezent') props.Prezent = '1'; else delete props.Prezent;
    var line = Number(b.dataset.line); var qty = Number(b.dataset.qty);
    var p = qty > 1
      ? api('cart/change.js', { line: line, quantity: qty - 1 }).then(function () { return api('cart/add.js', { items: [{ id: Number(b.dataset.vid), quantity: 1, properties: props }] }); })
      : api('cart/change.js', { line: line, quantity: qty, properties: props });
    return p;
  }
  function ustawPudelko(vid) {
    return koszyk().then(function (cart) {
      var jest = cart.items.filter(function (i) { return i.handle === PUD; });
      if (jest.length === 1 && String(jest[0].variant_id) === String(vid)) return null;
      var up = {}; jest.forEach(function (i) { up[i.key] = 0; });
      var p = jest.length ? api('cart/update.js', { updates: up }) : Promise.resolve();
      return vid ? p.then(function () { return api('cart/add.js', { items: [{ id: Number(vid), quantity: 1, properties: { _grupa: '1' } }] }); }) : p;
    });
  }
  function ustawWysylke(kpr, inny) {
    var d = dane(kpr);
    return koszyk().then(function (cart) {
      var jest = cart.items.filter(function (i) { return i.handle === WYS; });
      if (inny && d.rynek === 'pl' && d.wys && !jest.length) return api('cart/add.js', { items: [{ id: Number(d.wys), quantity: 1, properties: { _grupa: '1' } }] });
      if (!inny && jest.length) { var up = {}; jest.forEach(function (i) { up[i.key] = 0; }); return api('cart/update.js', { updates: up }); }
      return null;
    });
  }
  function operacja(el, fn) {
    zajety(el, true);
    return Promise.resolve().then(fn).then(koszyk).then(odswiez)
      .catch(function (err) { console.error('jsl-prezent', err); })
      .finally(function () { zajety(el, false); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var b = t.closest('[data-jsl-przenies]');
    if (b) { e.preventDefault(); b.disabled = true; return operacja(b, function () { return przenies(b); }); }
    b = t.closest('[data-jsl-drugi]');
    if (b) { e.preventDefault(); b.disabled = true; return operacja(b, function () { return api('cart/add.js', { items: [{ id: Number(b.dataset.vid), quantity: 1, properties: { Prezent: '1' } }] }); }); }
    b = t.closest('[data-jsl-dodaj-pr]');
    if (b) {
      e.preventDefault(); b.disabled = true;
      var ids = String(b.dataset.jslDodajPr).split(',').filter(Boolean);
      return operacja(b, function () { return api('cart/add.js', { items: ids.map(function (id) { return { id: Number(id), quantity: 1, properties: { Prezent: '1' } }; }) }); })
        .then(function () { if (!document.querySelector('cart-items-component')) { var a = document.createElement('a'); a.href = root + 'cart'; location.href = a.href; } });
    }
    b = t.closest('[data-jsl-otworz-dobor]');
    if (b) {
      var det = document.getElementById('j-pdp-dobor');
      if (det) { e.preventDefault(); det.open = true; det.scrollIntoView({ behavior: 'smooth', block: 'center' }); var s = det.querySelector('summary'); if (s) s.focus({ preventScroll: true }); }
      return;
    }
    b = t.closest('[data-jsl-otworz-zapytaj]');
    if (b && !window.jslDoradca) {
      var z = document.querySelector('[data-jsl-zapytaj]');
      if (z) { e.preventDefault(); e.stopPropagation(); z.open = true; var zs = z.querySelector('summary'); if (zs) zs.focus({ preventScroll: true }); }
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-jsl-pr-on]')) return ustawPrezent(t.closest('[data-jsl-prezent-pdp]'), t.checked);
    if (t.name && t.name.indexOf('jsl-sub-') === 0) {
      var p = t.closest('[data-jsl-sub]').querySelector('[data-jsl-sub-pole]');
      if (p) { p.value = t.value; p.disabled = !t.value; }
      return;
    }
    var kpr = t.closest('[data-jsl-kpr]'); if (!kpr) return;
    if (t.name === 'jsl-kpud') return operacja(t, function () { return zapiszAtrybuty(kpr, true).then(function () { return ustawPudelko(t.value); }); });
    if (t.name === 'jsl-kadr') {
      var inny = t.value === 'inny';
      var pola = kpr.querySelector('[data-jsl-kadr-pola]'); if (pola) pola.hidden = !inny;
      return operacja(t, function () { return zapiszAtrybuty(kpr, true).then(function () { return ustawWysylke(kpr, inny); }); });
    }
    if (t.name === 'jsl-kdok') { var f = kpr.querySelector('[data-jsl-kfak]'); if (f) f.hidden = t.value !== 'faktura'; }
    zapiszAtrybuty(kpr, true);
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    var licz = t.matches('textarea[maxlength]') && t.parentNode.querySelector('[data-jsl-licznik]');
    if (licz) licz.textContent = t.value.length + '/' + t.getAttribute('maxlength');
    var kpr = t.closest('[data-jsl-kpr]');
    if (kpr && t.matches('[data-jsl-kpole]')) { t.removeAttribute('aria-invalid'); zapiszAtrybuty(kpr, false); }
  });

  // przejście do kasy: najpierw dokończ zapis atrybutów, sprawdź adres odbiorcy i NIP
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#checkout, button[name="checkout"]');
    var kpr = document.querySelector('[data-jsl-kpr]');
    if (!btn || !kpr || btn.dataset.jslOk) return;
    var blad = kpr.querySelector('[data-jsl-kblad]');
    var braki = [];
    if (wybrane(kpr, 'jsl-kadr') === 'inny' && dane(kpr).rynek === 'pl') kpr.querySelectorAll('[data-jsl-kadr-pola] [data-wymagane]').forEach(function (p) { if (!p.value.trim()) braki.push(p); });
    if (wybrane(kpr, 'jsl-kdok') === 'faktura' && !wart(kpr, 'nip')) braki.push(pole(kpr, 'nip'));
    e.preventDefault(); e.stopImmediatePropagation();
    if (braki.length) {
      braki.forEach(function (p) { p.setAttribute('aria-invalid', 'true'); });
      if (blad) { blad.hidden = false; blad.textContent = blad.dataset.tekst || (braki[0] === pole(kpr, 'nip') ? kpr.dataset.bladNip : kpr.dataset.bladAdres) || ''; }
      braki[0].focus(); braki[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (blad) blad.hidden = true;
    (zapisTrwa || zapiszAtrybuty(kpr, true)).then(function () {
      btn.dataset.jslOk = '1';
      if (btn.form && btn.form.requestSubmit) btn.form.requestSubmit(btn); else btn.click();
    });
  }, true);

  var planuj = null;
  function przygotuj() { przygotujPdp(); przygotujKoszyk(); }
  new MutationObserver(function () { clearTimeout(planuj); planuj = setTimeout(przygotuj, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', przygotuj); else przygotuj();
})();
